import { OrganizationSubscriptionDto } from "@intelligems/ig-types";

export const getIsSubscriptionActive = (
  organizationSubscriptions: OrganizationSubscriptionDto[]
) => {
  return (organizationSubscriptions || []).some(
    (sub) => sub.subscriptionStatus === "active"
  );
};
